import { useEffect, useState } from 'react';

import { Board, BoardOrder } from 'types';

import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { hasPartnersDecoupled } from 'utils/showDetails';
import { getRepresented, getCurrentRepresented } from '../utils/getRepresented';
import { Represented } from '../types/Represented';

type Props = {
  partnerId: string;
  board: Board;
  order: BoardOrder;
};

export const useGetRepresented = ({ partnerId, order, board }: Props) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const partners = useSelector((state: State) => state.partners);

  const [representedWithInstructions, setRepresentedWithInstructions] =
    useState<Represented[]>([]);

  const [representedWithoutInstructions, setRepresentedWithoutInstructions] =
    useState<Represented[]>([]);

  const [currentRepresented, setCurrentRepresented] = useState<
    Represented | undefined
  >();

  useEffect(() => {
    const currentPartners = hasPartnersDecoupled()
      ? partners || []
      : actualSociety?.partners || [];

    const representedInstructions = getRepresented({
      partnerId,
      board,
      order,
      partners: currentPartners,
      withInstructions: true,
    });

    const representedNonInstructions = getRepresented({
      partnerId,
      board,
      order,
      partners: currentPartners,
      withInstructions: false,
    });

    const represented = getCurrentRepresented({
      partnerId,
      board,
      order,
      partners: currentPartners,
    });

    const filteredRepresentedInstructions = representedInstructions.filter(
      (represented) => !represented?.vote
    );

    const filteredRepresentedNonInstructions =
      representedNonInstructions.filter((represented) => !represented?.vote);

    setCurrentRepresented(represented);
    setRepresentedWithInstructions(filteredRepresentedInstructions);
    setRepresentedWithoutInstructions(filteredRepresentedNonInstructions);
  }, [actualSociety, board, order, partnerId, partners]);

  return {
    data: {
      representedWithInstructions,
      representedWithoutInstructions,
      currentRepresented,
    },
    isLoading: false,
    isError: false,
  };
};
